import { colors } from '../../Colors/colors'

export const simpleTableTheme = {
   light: {
      tableTheme: {
         borderColor: 'border-gray-300',
         countLabelColor: 'text-gray-600',
         countValueColor: 'text-gray-700',
         executionLogsContainerBgColor: 'bg-gray-100',
         headerNameColor: 'text-gray-600',
         tableCell: {
            cellTextColor: 'text-gray-600'
         },
         copyIconColor: colors['gray-500']
      },
      closeIconColor: colors['gray-500'],
      jsonPreview: {
         jsonPreviewHeadingColor: 'text-gray-600',
         borderColor: 'border-gray-300'
      },
      downloadLinkTheme: {
         downloadIconFillColor: colors['primary-600'],
         failureViewTextColor: 'text-gray-600',
         refreshIconFillColor: colors['error-700']
      },
      bulkActions: {
         xCloseIconColor: colors['gray-400'],
         selectedTextColor: 'text-primary-600',
         verticalLineColor: 'bg-gray-300',
         checkSquareIconColor: colors['primary-600'],
         hrLineColor: 'bg-gray-300'
      },
      inputCell: {
         borderColor: 'border-primary-600'
      }
   },

   dark: {}
}
